import { combineReducers } from "redux";
import modalReducer from "./modalReducer";
import usersReducer from "./usersReducer";
import sitesReducer from "./sitesReducer";
import visitsReportReducer from '../admin/VisitsReport';
import hl7ReceivedMessagesReducer from "./hl7ReceivedMessagesReducer";
import hl7SentMessagesReducer from "./hl7SentMessagesReducer";
import loggedInUsersReducer from "./loggedInUsersReducer";
import lockedVisitsReducer from "./lockedVisitsReducer"
import risReducer from "./risReducer";
import mipsReducer from "./mipsReducer";
import groupsReducer from "./groupsReducer";
import hl7QueueReducer from "./hl7QueueReducer";
import userMipsReducer from "./userMipReducer";

const adminReducer = combineReducers({
    modal: modalReducer,
    users: usersReducer,
    sites: sitesReducer,
    userMips:userMipsReducer,
    visitsReport: visitsReportReducer,
    hl7receivedmessages: hl7ReceivedMessagesReducer,
    hl7SentMessages: hl7SentMessagesReducer,
    loggedInUsers: loggedInUsersReducer,
    lockedVisits: lockedVisitsReducer,
    ris: risReducer,
    mips: mipsReducer,
    groups: groupsReducer,
    hl7Queue: hl7QueueReducer
});

export default adminReducer;
